import { NgModule } from '@angular/core';
import { GetBgColorPipe } from 'app/main/shared/pipes/get-bg-color-pipe/get-bg-color.pipe';

@NgModule({
  declarations: [GetBgColorPipe],
  exports: [GetBgColorPipe],
})
export class GetBgColorPipeModule {}
